class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0, undefined, this.dataset.disableGiftAdding);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartNotification = document.querySelector('cart-notification');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  async addOrRemoveGiftToCart(data) {
    const productsToAdd = [];
    const productsToRemove = [];

    if (window.gift_with_purchase?.gift_by === 'cart_amount') {
      const tiers = window.gift_with_purchase?.gift_tiers.filter((tier) => tier.amount > 0).sort((a, b) => a.amount - b.amount);

      const allGifts = tiers.flatMap(tier => tier.variant_ids)

      let cartAmountWithoutGifts = data.items
          .filter((item) => allGifts.indexOf(item.id) === -1)
          .reduce((sum, item) => sum + item.final_line_price, 0);

      tiers.forEach((tier) => {
        if (tier?.variant_ids?.length <= 0) return;

        let meetsGWPCriteria = false;
        const giftsAlreadyInCart = [];
        const itemsWithTag = []
        const applicableGifts = tier.variant_ids;

        data.items.forEach((value) => {
          if (applicableGifts?.some((id) => +id === +value.id && value.properties['_gwp'])) {
            giftsAlreadyInCart.push(value);
          }

          if(tier.tags?.length > 0){
            data.items
            .forEach((item) => {
              if(tier.tags.some(tag => tag === item.product_type)){
                itemsWithTag.push(item)
              }
            })
          }

        });
        const itemsWithTagTotal = itemsWithTag?.length > 0 ? itemsWithTag.sort(
          (a, b) =>
            Number(a.final_price || 0) -
            Number(b.final_price || 0)
        )[0].final_price : 0

        if (Number(cartAmountWithoutGifts - itemsWithTagTotal) >= tier.amount * 100) {
          meetsGWPCriteria = true;
        }

        applicableGifts.forEach((gift) => {
          const alreadyInCart = giftsAlreadyInCart.some((item) => item.id === gift);

          if (alreadyInCart && !meetsGWPCriteria) {
            productsToRemove.push(gift);
          } else if (!alreadyInCart && meetsGWPCriteria) {
            productsToAdd.push(gift);
          }
        });
      });
    } else if (window.gift_with_purchase?.gift_by === 'adding_product_with_tags') {
      if (!window.gift_with_purchase?.gift_tags_variant_ids?.length) return;

      let meetsGWPCriteria = false;
      const applicableGifts = window.gift_with_purchase?.gift_tags_variant_ids;
      const applicableTags = window.gift_with_purchase?.gift_tags?.split(',')?.map(tag => tag.trim());
      const giftsAlreadyInCart = [];

      data.items.forEach((value) => {
        if (applicableGifts?.some((id) => +id === +value.id) && value.properties['_gwp']) {
          giftsAlreadyInCart.push(value.id);
        }
      });

      const productTags = await Promise.all(
        data.items.map(async (el) => {
          let productInfo = await fetch(`/products/${el.handle}.json`);
          productInfo = await productInfo.json();
          console.log('productInfo', productInfo)
          return productInfo?.product?.tags || [];
        })
      );

      productTags?.forEach((pt) => {
        if (meetsGWPCriteria) return;
        applicableTags?.forEach((at) => {
          if (pt.includes(at)) {
            meetsGWPCriteria = true;
            return;
          }
        });
      });

      applicableGifts.forEach((gift) => {
        const alreadyInCart = giftsAlreadyInCart.some((id) => id === gift);

        if (alreadyInCart && !meetsGWPCriteria) {
          productsToRemove.push(gift);
        } else if (!alreadyInCart && meetsGWPCriteria) {
          productsToAdd.push(gift);
        }
      });
    }

    if (productsToRemove.length > 0) {
      let updates = {};

      productsToRemove.forEach((id) => {
        updates[id] = 0;
      });

      fetch(`${routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates,
          sections: this
            .getSectionsToRender()
            .map((section) => section.id)
            .join(),
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
          });

          this.classList.toggle('is-empty', response.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          const cartBubble = document.querySelector('.ba-cart__bubble span');
          const miniCartItemCounter = document.querySelector('#mini-cart .ba-cart__title span');
          const miniCartRecommendations = document.querySelectorAll('#cart-product-recommendations');

          if (cartFooter) cartFooter.classList.toggle('is-empty', response.item_count === 0);
          if (miniCartRecommendations?.length) miniCartRecommendations.forEach((el) => el.classList.toggle('hidden', response.item_count === 0));

          if (cartBubble) {
            cartBubble.textContent = pad(response.item_count, 2);
          }

          if (miniCartItemCounter) {
            miniCartItemCounter.textContent = response.item_count == 0 ? '' : `(${response.item_count})`;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: response } }));
          return response;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    if (productsToAdd.length > 0) {
      const items = productsToAdd?.map((id) => {
        return {
          id: +id,
          quantity: 1,
          properties: {
            '_gwp': true,
          },
        };
      });

      fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: items,
          sections: this
            .getSectionsToRender()
            .map((section) => section.id)
            .join(),
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(response.sections[section.section], section.selector);
          });

          return response;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id || 'main-cart-items',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id || 'main-cart-footer',
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, disableGiftAdding) {
    const cartQuantityBtns = [...document.querySelectorAll('#main-cart-items button.quantity__button')];

    cartQuantityBtns.map((btn) => btn.setAttribute('disabled', true));

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        document.getElementById('cart-errors').textContent = '';

        if (parsedState.errors) {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
          document.getElementById('cart-errors').innerHTML += `<span>${parsedState.errors}</span>`;
          this.disableLoading();
          return;
        }

        const cartBubble = document.querySelector('.ba-cart__bubble span');
        const miniCartItemCounter = document.querySelector('#mini-cart .ba-cart__title span');
        const miniCartRecommendations = document.querySelectorAll('#cart-product-recommendations');

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: parsedState } }));

        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (miniCartRecommendations?.length) miniCartRecommendations.forEach((el) => el.classList.toggle('hidden', parsedState.item_count === 0));

        if (cartBubble) {
          cartBubble.textContent = pad(parsedState.item_count, 2);
        }

        if (miniCartItemCounter) {
          miniCartItemCounter.textContent = parsedState.item_count == 0 ? '' : `(${parsedState.item_count})`;
        }

        function pad(n, width, z) {
          z = z || '0';
          n = n + '';
          return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        if (window.gift_with_purchase?.available && !disableGiftAdding) {
          this.addOrRemoveGiftToCart(parsedState);
        }
      })
      .catch((err) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent += window.cartStrings.error;
        this.disableLoading();
      })
      .finally(() => {
        cartQuantityBtns.map((btn) => btn.removeAttribute('disabled'));

      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`).querySelector('.cart-item__error-text').innerHTML = window.cartStrings.quantityError.replace(
        '[quantity]',
        document.getElementById(`Quantity-${line}`).value
      );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

// Make Shopify payments buttons clickable via ENTER key
(function () {
  const dynamicCheckoutButtons = document.querySelector('.cart__dynamic-checkout-buttons');
  if (!dynamicCheckoutButtons) {
    return;
  }
  dynamicCheckoutButtons.addEventListener('keydown', (event) => {
    if (event.which === 13) {
      const focusedButton = dynamicCheckoutButtons.querySelector("button:focus, [role='button']:focus");
      if (focusedButton) {
        focusedButton.click();
      }
    }
  });
})();
class CartPromotions extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.cart-promotions');
    this.progressBar = this.querySelector('.cart-promotions__tiers-progress-bar');
    this.bubbles = this.querySelectorAll('.cart-promotions__tiers-bubble');
    this.message = this.querySelector('.cart-promotions__message');
    this.modalButton = document.querySelector('.cart-promotions__button');
    this.modalCloseButton = document.querySelector('.cart-promotions__modal-close');
    this.modalOverlay = document.querySelector('.cart-promotions__modal-overlay');
    this.modal = document.querySelector('.cart-promotions__modal');
    this.giftBanner = this.querySelector('.cart-promotions__gift');
    this.freeShippingAmount = this.querySelector('.cart-promotions__tiers-bubble.free-shipping-bubble')?.dataset.completedValue;
    this.gwpEnabled = window.gift_with_purchase?.available && window?.gift_with_purchase?.gift_by === 'cart_amount'
    this.gwpTiers = this.gwpEnabled ? window.gift_with_purchase?.gift_tiers?.filter((tier) => tier?.amount).sort((a, b) => Number(a?.amount) - Number(b?.amount)) : [];
    this.highestTier = this.gwpEnabled ? this.gwpTiers[this.gwpTiers?.length - 1] : +this.freeShippingAmount;

    this.getCart().then(() => {
      this.renderPromotions();
    });

    document.addEventListener('cart:updated', (e) => {
      if (!e?.detail?.cart) return;
      this.cart = e.detail.cart
      this.subtotal = this.getSubtotal(e?.detail?.cart);
      this.renderPromotions();
    });

    this.modalButton?.addEventListener('click', () => this.toggleModal());
    this.modalCloseButton?.addEventListener('click', () => this.toggleModal());
    this.modalOverlay?.addEventListener('click', () => this.toggleModal());
  }

  getSubtotal(cart) {
    return Number(cart?.total_price / 100)
    //return items.filter((item) => !item.properties?._gwp)?.reduce((sum, item) => (sum += item.final_line_price), 0) / 100;
  }

  async getCart() {
    return fetch('/cart.json')
      .then((res) => res.json())
      .then((data) => {
        this.cart = data
        if (data?.items) {
          this.subtotal = this.getSubtotal(data);
        }
      });
  }

  calculateProgressBarWidth() {
    const tiersAmount = this.getTiersWithFinalPrice().map(tier => tier.final_amount)
    const percentPerTier = 100 / (tiersAmount.length);

    if (this.subtotal <= tiersAmount[0]) {
      return `${(this.subtotal / tiersAmount[0]) * percentPerTier}%`;
    } else if (this.subtotal <= tiersAmount[1]) {
      return `${percentPerTier + ((this.subtotal - tiersAmount[0]) / (tiersAmount[1] - tiersAmount[0])) * percentPerTier}%`;
    } else if (this.subtotal <= tiersAmount[2]) {
      return `${2 * percentPerTier + ((this.subtotal - tiersAmount[1]) / (tiersAmount[2] - tiersAmount[1])) * percentPerTier}%`;
    } else if (this.subtotal <= tiersAmount[3]) {
      return `${3 * percentPerTier + ((this.subtotal - tiersAmount[2]) / (tiersAmount[3] - tiersAmount[2])) * percentPerTier}%`;
    } else {
      return `100%`;
    }
  }

  getTiersWithFinalPrice(){
    return this.gwpEnabled ? [{amount: +this.freeShippingAmount, final_amount: +this.freeShippingAmount}, ...this.gwpTiers.map((tier) => {
      if(tier?.tags?.length > 0){
        const itemsWithTag = this.cart?.items?.filter(item => tier.tags.some(tag => tag === item.product_type))
        const itemsWithTagFinalPrice = itemsWithTag?.length > 0 ? itemsWithTag.sort((a,b) => a.final_price - b.final_price)[0].final_price : 0
        return {...tier, final_amount: tier.amount + (itemsWithTagFinalPrice/100)}
      } else{
        return {...tier, final_amount: tier.amount}
      }
    })] : [{amount: +this.freeShippingAmount, final_amount: +this.freeShippingAmount}];
  }

  isTierCompleted(amount){
    const tiers = this.getTiersWithFinalPrice()
    const currentTier = tiers.find(tier => +tier.amount === +amount)
    return this.subtotal >= currentTier.final_amount
  }

  renderPromotions() {
    const tiers = this.getTiersWithFinalPrice()
    const nextTierAmount = tiers.find((tier) => tier.final_amount > this.subtotal)?.final_amount;
    const difference = Number(nextTierAmount - this.subtotal).toFixed(2);
    const completedTiers = tiers.filter((tier) => this.subtotal >= tier.final_amount && tier.variant_ids?.length > 0);

    this.container.classList.toggle('is-empty', this.subtotal <= 0);

    this.progressBar.style.width = this.calculateProgressBarWidth();

    this.bubbles.forEach((bubble) => {
      bubble.classList.toggle('completed', this.isTierCompleted(+bubble.dataset.completedValue));
    });
    this.modal.querySelectorAll('.cart-promotions__modal-tier')?.forEach(el => el.classList.toggle('completed', this.subtotal >= +el.dataset.completedValue))

    if (this.subtotal < this.freeShippingAmount) {
      this.message.innerText = `Add $${Number(+this.freeShippingAmount - this.subtotal).toFixed(2)} and get free shipping`;
    } else if(this.subtotal >= this.freeShippingAmount && !this.gwpEnabled){
      this.message.innerText = `You qualify for free shipping!`;
    } else if (this.gwpEnabled && this.subtotal === this.freeShippingAmount) {
      this.message.innerText = `You qualify for free shipping. $${difference} from free gift`;
    } else if (this.gwpEnabled && completedTiers.length > 0) {
      this.message.innerText = `You earned ${Number(completedTiers.reduce((sum, curr) => (sum += Number(curr?.variant_ids?.length + curr?.tags?.length)), 0))} gift!`;
    } else {
      this.message.innerText = `$${difference} away from your free gift!`;
    }

    if(this.gwpEnabled && this.giftBanner){
      this.giftBanner.style.display = this.subtotal >= +this.giftBanner.dataset?.cartPromoThreshold ? 'flex' : 'none'
    }
  }

  toggleModal() {
    this.modal.classList.toggle('active');
  }
}

customElements.define('cart-promotions', CartPromotions);

document.addEventListener('DOMContentLoaded', () => {

  const target = document.querySelector('#mini-cart');

  if(target){
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if(mutation.target.className.includes('mini-cart--open')){
                fetch('/cart.json').then(res => res.json()).then(data => {if(data) {Shopify?.analytics?.publish('minicart_viewed', {cart: data})}})
              }
          }
      });
  });
    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

})